<app-editor code="{{program}}"> </app-editor>